// AI Fluency's competencies (RFC-055, byj-1wv.51.20): a fluency rubric's
// parts on the Exams pages and a blueprint's :coverage keys in the bank's
// editor. A module of its own, depending on nothing, so the blueprint form's
// pure EDN reading does not load the Exams pages' words to get four names.

/** The competencies, in the order RFC-055 gives them (exam/competency-keys). */
export const competencies = ["delegation", "description", "discernment", "diligence"] as const;
export type Competency = (typeof competencies)[number];
